import { lazy } from 'react';

const PdfToPngTool = lazy(() => import('./Tools/PdfToPngTool'));
const PdfToolkit = lazy(() => import('./Tools/PdfToolkit'));
const ImageToolkit = lazy(() => import('./Tools/ImageToolkit'));
const OfficeToImageTool = lazy(() => import('./Tools/OfficeToImageTool'));
const QrcodeTool = lazy(() => import('./Tools/QrcodeTool'));
const LinkDiagnoseTool = lazy(() => import('./Tools/LinkDiagnoseTool'));
const DocumentCompareTool = lazy(() => import('./Tools/DocumentCompareTool'));

export const portalPageRoutes = [
  { path: '/portal/tools/pdf-to-png', component: PdfToPngTool },
  { path: '/portal/tools/pdf-toolkit', component: PdfToolkit },
  { path: '/portal/tools/image-toolkit', component: ImageToolkit },
  { path: '/portal/tools/office-to-image', component: OfficeToImageTool },
  { path: '/portal/tools/qrcode', component: QrcodeTool },
  { path: '/portal/tools/link-diagnose', component: LinkDiagnoseTool },
  { path: '/portal/tools/document-compare', component: DocumentCompareTool }
];
